import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const RibbonVariant = {
  NEUTRAL: 'neutral',
  YELLOW: 'yellow',
  DARK: 'dark',
} as const;

export type RibbonVariantType =
  (typeof RibbonVariant)[keyof typeof RibbonVariant];

export type RibbonProps = {
  text: string;
  iconName?: TUNDR_ICONS;
  variant?: RibbonVariantType;
  backgroundColor?: string;
  contrast?: boolean;
  testId?: string;
};
